import React, { useState } from 'react';
import './Tabulation.css';
import RangeDatePicker from '../RangeDatePicker/RangeDatePicker';
import { useSelector } from 'react-redux';
const TabulationComponent = ({handleTabClick}) => {
  const activeTab = useSelector((state) => state.operationHome.activeTab);
  const pageSize = useSelector((state) => state.operationHome.table.pageSize);
  return (
    <div className="T-tabulation-container">
      <ul className="T-option-list">
        <li>
          <button
            className={activeTab === "last24Hours" ? "T-selected" : ""}
            onClick={() => handleTabClick({ name: "last24Hours" , limit: pageSize} )}
          >
            Last 24 hours
          </button>
        </li>
        <li>
          <button
            className={activeTab === "last7Days" ? "T-selected" : ""}
            onClick={() => handleTabClick({ name: "last7Days" , limit: pageSize})}
          >
            Last 7 days
          </button>
        </li>
        <li>
          <button
            className={activeTab === "last30Days" ? "T-selected" : ""}
            onClick={() => handleTabClick({ name: "last30Days", limit: pageSize })}
          >
            Last 30 days
          </button>
        </li>
        <li>
          <button
            className={activeTab === "last365Days" ? "T-selected" : ""}
            onClick={() => handleTabClick({ name: "last365Days" , limit: pageSize})}
          >
            Last 365 days
          </button>
        </li>
        <li>
          <button
            className={activeTab === "range" ? "T-selected" : ""}
            onClick={() => handleTabClick({ name: "range" , limit: pageSize})}
          >
            Range
            <div className="T-range-picker-container">
              
              <RangeDatePicker
                isSelected={activeTab === "range"}
                onSendData={(data) =>
                  handleTabClick({ name: "range", ...data , limit: pageSize})
                }
                onClear={() => handleTabClick({ name: "last365Days", limit: pageSize })}
                maxDate={new Date()}
              />
            </div>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default TabulationComponent;
// const handleTabClick = (tab) => {
//   dispatch(setActiveTab(tab.name));
//   dispatch(setSelectedCard(null));
//   if (tab.name === "range" && !(tab.startDate && tab.endDate)) return;
//   dispatch(getOperationDataInit(tab));
//   // dispatch(fetchPerformanceDataInit(tab.name));

//   // dispatch(fetchRecommendationsStart(tab.name));
//   console.log("Dispatching getPerformanceDataInit with:", tab.name);
//   dispatch(getPerformanceDataInit(tab.name));

// };